export default {
    getDialetos: state => state.dialetos,
    isMostraPerpetua: state => state.flMostraPerpetua == 'S',
    isMostraCodigoSepultamento: state => state.flMostraCodigoSepultamento == 'S',
    isEmImplantacao: state => state.flEmImplantacao == 'S',
    getMenus: state => state.menus
};
